(function(angular) {
    'use strict';

    angular.module('sp360', []);
})(angular);
(function (angular) {
    "use strict";

    function sp360($timeout) {
        return {
            restrict: 'A',
            scope: {
                pattern: '@',
                imagesDirectory: '@',
                numberOfImages: '<?',
                initialImageIndex: '<?',
                zoomButtons: '<?',
                clickableArea: '<?',
                resetZoom: '&?',
                zoomIn: '&?',
                zoomOut: '&?',
                enableZoomOut: '<?'
            },
            link: function ($scope, $element) {
                var _view,
                    _prevSize,
                    _intervalId,
                    _debounceTimeout;
                $scope.pattern = $scope.pattern || 'image_%COL_%ROW.jpg';
                $scope.numberOfImages = $scope.numberOfImages || 36;
                $scope.initialImageIndex = $scope.initialImageIndex || 0;

                _init();
                _intervalId = setInterval(_compareSize, 200);

                _watch('imagesDirectory', _initDebounce);
                _watch('pattern', _initDebounce);
                _watch('numberOfImages', _initDebounce);
                _watch('zoomButtons', function(newVal) {
                    _view.toggleZoomButtons(newVal);
                });
                _watch('enableZoomOut', function(newVal) {
                    _view.setNavigationConfig({ zoomOutEnabled: !!$scope.enableZoomOut });
                    _view.toggleZoomButtons();
                });
                _watch('clickableArea', function(newVal) {
                    _view.toggleClickableArea(newVal);
                });

                if ($scope.resetZoom) {
                    $scope.resetZoom({ callback: _resetZoom });
                }

                function _resetZoom() {
                    if (_view) {
                        _view.resetZoom();
                    }
                }

                function _init() {
                    _view = new View360();

                    _view.setNavigationConfig({
                        btnMargin: 14,
                        type: 'round',
                        showTool: false,
                        showClose: false,
                        showPlay: false,
                        showPause: false,
                        showFullscreen: false,
                        showZoom: $scope.zoomButtons === undefined || !!$scope.zoomButtons,
                        zoomOutEnabled: !!$scope.enableZoomOut,
                        clickableArea: $scope.clickableArea === undefined || !!$scope.clickableArea,

                        //custom variable
                        autoPan: true
                    });
                    _view.setImagesPattern($scope.pattern);
                    _view.setImagesDirectory($scope.imagesDirectory);

                    _view.setConfig({
                        width: $element.prop('clientWidth'),
                        height: $element.prop('clientHeight'),
                        columns: $scope.numberOfImages,
                        imagesNumbering: $scope.initialImageIndex,
                        zoomMultipliers: [1, 3, 6, 9],
                        // TODO if the order of the gs1 files will change, I'll make this configurable
                        //or remove i.e. keep the default behaviour
                        opositeDirection: true
                    });

                    _view.setSpEvent('minZoomIn', _spEvent('zoomIn'));
                    _view.setSpEvent('maxZoomOut', _spEvent('zoomOut'));

                    _view.start($element[0]);
                }

                function _initDebounce() {
                    if (_debounceTimeout) {
                        $timeout.cancel(_debounceTimeout);
                    }

                    _debounceTimeout = $timeout(function() {
                        _init();
                        _debounceTimeout = undefined;
                    }, 200);
                }

                function _spEvent(eventName) {
                    return function(options) {
                        var result = true;

                        if ($scope[eventName]) {
                            result = $scope[eventName](options);
                            $scope.$apply();

                            setTimeout(_compareSize, 50);
                        }

                        return result;
                    };
                }

                function _compareSize() {
                    if (!_view) {
                        return;
                    }

                    var newSize = $element.prop('clientWidth') + '-' + $element.prop('clientHeight'),
                        is = _prevSize !== newSize;
                    _prevSize = newSize;

                    if (is) {
                        _view.setConfig({
                            width: $element.prop('clientWidth'),
                            height: $element.prop('clientHeight')
                        });
                        _view.resizeReset();
                    }
                }

                function _watch(prop, callback) {
                    $scope.$watch(prop, function(newVal) {
                        if (_view && newVal !== undefined) {
                            callback(newVal);
                        }
                    });
                }

                $scope.$on('$destroy', function () {
                    if (_view) {
                        _view.destroy();
                        _view = undefined;
                    }

                    clearInterval(_intervalId);
                });
            }
        };
    }

    angular
        .module('sp360')
        .directive('sp360', ['$timeout', sp360]);
})(angular);


/*
 * View360 version 1.4.3
 */

var View360 = function (consObj) {

    this.consObj = consObj;

    this.navigationConfig = {
        btnMargin: 5,
        showButtons: true,
        showTool: true,
        showMove: true,
        showRotate: true,
        showPlay: true,
        showPause: true,
        showZoom: true,
        showTurn: true,
        turnSpeed: 40,
        showFullscreen: true,
        showClose: true,
        clickableArea: true, // sp custom property
        align: "center", // left | center | right  // v1.1.0
        orientation: "horizontal", // vertical | horizontal  // v1.1.0
        type: "square" // square | round | custom  // v1.1.0
    };

    this.config = {
        verticalAngles: {
            from: 15,
            to: 45,
            initial: 15
        },
        horizontalAngles: {
            from: 0,
            to: 360,
            initial: 0
        },

        opacity: 1,
        mode: "fixed",
        width: 620,
        height: 350,

        fitmode: "left-right", //v 1.3.0

        oneTurnOnStartUp: true, //v 1.1.0

        autoRotate: false,
        autoRotateDirection: 1,
        autoRotateSpeed: 50,
        autoRotateStopOnMove: true,

        zoomMultipliers: [1, 1.2, 1.5, 2, 3],

        loadFullSizeImagesOnZoom: true,
        loadFullSizeImagesOnFullscreen: true,

        initialImage: 0, // v1.3.0

        imagesDirectory: ".",
        fullSizeImagesDirectory: "",
        images: [],
        autoLoadImages: true,
        imagesPattern: "image_%COL_%ROW.jpg",
        imagesNumbering: 0, // v1.3.0

        showTurnMeOn: false,  // v1.3.0

        rows: 1,
        columns: 36,
        xAxisSensitivity: 10,
        yAxisSensitivity: 40,
        inertiaConstant: 10,
        panInBounds: false,
        playBtnMode: "loop", //v1.0.9 loop | oneloop | firstimage | lastimage

        opositeDirection: false, //v1.1.1
        loadOnPageLoad: false,//v1.3.0

        firstImageOpacity: 0.5, //v1.1.0
        loadFirstImage: true,//v1.3.0

        imagesNumberingUpDown: 0 //v1.4.0

    };

    this.loaderInfoClass = View360LoadingInfo;
    this.loaderInfoConfig = {};
    this.fullSizeLoaderInfoClass = View360LoadingInfo;
    this.fullSizeLoaderInfoConfig = {
        display: false,
        holderClassName: "View360-fullSizeLoader",
        circleLineWidth: 25,
        circleLineColor: "#AAAAAA",
        modalOpacity: 0,
        loadingTitle: "Loading fullsize images...",
        circleWidth: 50
    };

    this.addCloseToDom = function (holder) {
        holder.innerHTML +=  this.closeButtons.close;
    };

    this.addNavButtonsToDom = function (holder) {

        var html = "";
        for (var i = 0; i < this.navButtonsOrder.length; i++) {
            var alias = this.navButtonsOrder[i];
            html += this.navButtons[alias];
        }
        holder.innerHTML = html;

    };

    this.addNavButton = function (alias, html) {
        this.navButtons[alias] = html;
        this.navButtonsOrder.push(alias);
    };

    this.navButtons = {
        "rotate": '<div class="View360-navigationRotate View360-navigationBtn" role="button" tabindex="0" aria-label="rotate"></div>',
        "move": '<div class="View360-navigationHand View360-navigationBtn" role="button" tabindex="0" aria-label="move"></div>',
        "play": '<div class="View360-navigationPlay View360-navigationBtn" role="button" tabindex="0" aria-label="play"></div>',
        "pause": '<div class="View360-navigationPause View360-navigationBtn" role="button" tabindex="0" aria-label="pause"></div>',
        "turn-left": '<div class="View360-navigationTurnLeft View360-navigationBtn" role="button" tabindex="0" aria-label="turn left"></div>',
        "turn-right": '<div class="View360-navigationTurnRight View360-navigationBtn" role="button" tabindex="0" aria-label="turn right"></div>',
        "zoom-in": '<div class="View360-navigationZoomIn View360-navigationBtn" role="button" tabindex="0" aria-label="zoom in"></div>',
        "zoom-out": '<div class="View360-navigationZoomOut View360-navigationBtn" role="button" tabindex="0" aria-label="zoom out"></div>',
        "fullscreen": '<div class="View360-navigationFullscreenEnter View360-navigationBtn" role="button" tabindex="0" aria-label="fullscreen"></div><div class="View360-navigationFullscreenExit View360-navigationBtn" role="button" tabindex="0" aria-label="exit fullscreen"></div>'
    };
    this.closeButtons = {
        "close": '<div class="View360-navigationClose View360-navigationBtn"></div>'
    }
   /*  this.closeButtons = {
        "rotate": '<div class="View360-navigationRotate View360-navigationBtn"></div>',*/

    this.navButtonsOrder = ["rotate", "move", "play", "pause", "turn-left", "turn-right", "zoom-in", "zoom-out", "fullscreen"];
    this.setNavButtonsOrder = function (navButtonsOrder) {
        this.navButtonsOrder = navButtonsOrder;
    };

    this.htmlTemplate = ' ';
    this.htmlTemplate += '   <div class="View360-holder"> ';
    this.htmlTemplate += '       <div class="View360-canvasHolder"> ';
    this.htmlTemplate += '           <canvas class="View360-canvas"></canvas> ';
    this.htmlTemplate += '       </div> ';
    this.htmlTemplate += '       <div class="View360-borderHolder View360-loadingBackground"></div> ';
    this.htmlTemplate += '       <div class="View360-loaderHolder"></div> ';
    this.htmlTemplate += '       <div class="View360-fullSizeLoaderHolder"></div> ';
    this.htmlTemplate += '       <div class="View360-clickableArea"></div> ';
    this.htmlTemplate += '<div class="View360-turnMeOnHolder"><div class="View360-turnMeOn"></div></div>';

    this.htmlTemplate += '<div class="View360-closeHolder">';
    this.htmlTemplate += '</div> ';

    this.htmlTemplate += '<div class="View360-navigationHolder">';
    this.htmlTemplate += '<div class="View360-navigation" role="application">';

    this.htmlTemplate += '</div> ';
    this.htmlTemplate += '</div> ';
    this.htmlTemplate += '       <div class="View360-close"></div> ';
    this.htmlTemplate += '   </div>';

    this.globalPanMoveX = 0;
    this.globalPanMoveY = 0;
    this.currentPanMoveX = 0;
    this.currentPanMoveY = 0;
    this.currentZoom = 1;

    this.isFullscreen = false;

    this.ctx = null;
    this.totalImages = 0;

    this.cols;
    this.rows;
    this.totalImages;

    this.autoRotatePaused = false;
    this.mouseDown = false;
    this.refMouseX;
    this.refMouseY;
    this.refCol;
    this.refRow;
    this.currentCol = 0;
    this.currentRow = 0;
    this.refCol = this.currentCol;
    this.refRow = this.currentRow;

    this.autoCol = 0;

    this.images = [];

    this.clickableAreaObj = null;

    this.oldBodyOverflowX="unset";

    this.rememberInertiaInterval = null;
    this.inertiaStatesArr = [];
    this.stopRememberInertiaInterval = function () {
        clearInterval(this.rememberInertiaInterval);
    };

    this.inertiaPrevStateX = null;
    this.inertiaPrevStateY = null;
    this.allowInertia = false;
    this.startRememberInertiaInterval = function () {
        var self = this;
        this.inertiaStatesArr = [];
        this.rememberInertiaInterval = setInterval(function () {

            if (self.inertiaPrevStateX == self.currentMoveX && self.inertiaPrevStateY == self.currentMoveY) {
                self.allowInertia = false;
            } else {
                self.allowInertia = true;
            }

            self.inertiaPrevStateX = self.currentMoveX;
            self.inertiaPrevStateY = self.currentMoveY;

        }, 30);
    };

    this.rememberInertiaStates = function () {

        var self = this;
        if (self.inertiaStatesArr.length == 0) {

            self.inertiaStatesArr.push({
                moveX: self.currentMoveX,
                moveY: self.currentMoveY
            });
            self.inertiaStatesArr.push({
                moveX: self.currentMoveX,
                moveY: self.currentMoveY
            });
            self.inertiaStatesArr.push({
                moveX: self.currentMoveX,
                moveY: self.currentMoveY
            });
            self.inertiaStatesArr.push({
                moveX: self.currentMoveX,
                moveY: self.currentMoveY
            });
            self.inertiaStatesArr.push({
                moveX: self.currentMoveX,
                moveY: self.currentMoveY
            });

        }

        var newItem = {
            moveX: self.currentMoveX,
            moveY: self.currentMoveY
        };

        self.inertiaStatesArr.push({
            moveX: self.currentMoveX,
            moveY: self.currentMoveY
        });
        self.inertiaStatesArr.shift();

    };


    this.inertiaAutoMoveInterval = null;
    this.startInertiaAutoMoveInterval = function (initial) {

        var self = this;

        if (initial) {
            var diff = 24;
        } else {
            if (!this.allowInertia) {
                this.autoRotatePaused = false;
                return;
            }

            this.stopInertiaAutoMoveInterval();


            try {
                var diff = self.inertiaStatesArr[self.inertiaStatesArr.length - 1].moveX - self.inertiaStatesArr[0].moveX
                if (diff == 0) {
                    return;
                }
            } catch (ex) {
                return;
            }

            diff = diff / 10;
            diff = self.getDirection(diff) * Math.min(15, Math.abs(diff));

        }

        this.refCol = this.currentCol;
        this.refRow = this.currentRow;

        var initialVelocity = Math.abs(diff);
        var scaleFactor = 1.5;  // 1 je ok
        var amplitude = initialVelocity * scaleFactor;
        var step = 0;

        var timeConstant = 6;  // 3 je ok

        var updateInterval = 10; // 10 je ok
        var position = 0;

        this.inertiaAutoMoveInterval = setInterval(function () {
            var delta = amplitude / timeConstant;
            position += delta;
            amplitude -= delta;
            step += 1;
            if (step > 6 * timeConstant) {
                self.autoRotatePaused = false;
                clearInterval(self.inertiaAutoMoveInterval);
            }

            self.autoColMove(self.getDirection(diff) * Math.round(position))

        }, updateInterval);

    };

    this.stopInertiaAutoMoveInterval = function () {
        clearInterval(this.inertiaAutoMoveInterval);
    }

    this.autoColMove = function (moveCol) {

        if (moveCol == 0)
            return;

        var dirX = -1; //- this.getDirection(moveCol);
        this.currentCol = (this.refCol + (dirX * moveCol)) % this.cols;
        this.currentCol = this.currentCol < 0 ? this.currentCol + this.cols : this.currentCol;

        this.autoCol = this.currentCol;

        var idx = this.getIdxByColRow(this.currentCol, this.currentRow);

        this.displayImageByIdx(idx);

    };

    this.mouseDownHandler = function (x, y) {


        var self = this;

        if (this.config.hideOnMouseTurnMeOn) {
            V360Util.addClass(this.turnMeOnHolder, "View360-opacity0");
        }

        if (this.config.autoRotateStopOnMove) {
            this.stopAutoRotate();
        }

        this.stopInertiaAutoMoveInterval();
        this.startRememberInertiaInterval();

        this.refCol = this.currentCol;
        this.refRow = this.currentRow;
        this.refMouseX = x;
        this.refMouseY = y;

        if (this.mouseDown)
            return;

        this.autoRotatePaused = true;
        this.mouseDown = true;

        V360Util.removeEvent(document, "touchmove", this.touchMoveHandlerListener);
        this.touchMoveHandlerListener = function (event) {
            if (event.touches.length > 1) {
                return;
            }

            event.preventDefault();
            self.mouseMoveHandler(event.touches[0].pageX, event.touches[0].pageY);

        };

        V360Util.addEvent(document, "touchmove", this.touchMoveHandlerListener, false);

        V360Util.removeEvent(document, "mousemove", this.mouseMoveHandlerListener);
        this.mouseMoveHandlerListener = function (event) {
            self.mouseMoveHandler(event.pageX, event.pageY);
        };

        V360Util.addEvent(document, "mousemove", this.mouseMoveHandlerListener, false);

        // mouseup
        V360Util.removeEvent(document, "mouseup", this.mouseUpHandlerListener);
        V360Util.removeEvent(this.clickableAreaObj, "touchend", this.mouseUpHandlerListener);
        this.mouseUpHandlerListener = function (event) {
            self.mouseUpHandler(event);
        };

        V360Util.addEvent(document, "mouseup", this.mouseUpHandlerListener, false);
        V360Util.addEvent(this.clickableAreaObj, "touchend", this.mouseUpHandlerListener, false);

    };

    this.setRelativePosition = function (x, y) {
        this.globalPanMoveX = x;
        this.globalPanMoveY = y;
    };

    this.mouseUpHandler = function (evt) {

        evt.stopPropagation();

        this.mouseDown = false;

        this.currentPanMoveX = 0;
        this.currentPanMoveY = 0;


        if (this.isPanMode()) {
            this.globalPanMoveX = -((this.zoomedXPosMoved - this.zoomedXPosCentered - this.panMoveEmptyX) / this.currentZoom); //fullscreenZoom
            this.globalPanMoveY = -((this.zoomedYPosMoved - this.zoomedYPosCentered - this.panMoveEmptyY) / this.currentZoom); //fullscreenZoom
            this.panMoveEmptyX = 0;
            this.panMoveEmptyY = 0;
        }

        V360Util.removeEvent(document, "mousemove", this.mouseMoveHandlerListener);
        V360Util.removeEvent(document, "touchmove", this.touchMoveHandlerListener);
        V360Util.removeEvent(document, "mouseup", this.mouseUpHandlerListener);
        V360Util.removeEvent(this.clickableAreaObj, "touchend", this.mouseUpHandlerListener);

        this.stopRememberInertiaInterval();
        this.startInertiaAutoMoveInterval();
    };

    this.setMoveMode = function (moveMode) {
        this.moveMode = moveMode;

        this._setCliackableAreaClass();
    };

    this._setCliackableAreaClass = function() {
        var $element = angular.element(V360Util.getFirstElementByClassName(this.innerHolder, 'View360-clickableArea')),
            panModeClass = 'pan-mode',
            rotateModeClass = 'rotate-mode';
        $element.removeClass(panModeClass);
        $element.removeClass(rotateModeClass);
        if (this.isPanMode()) {
            $element.addClass(panModeClass);
        } else {
            $element.addClass(rotateModeClass);
        }
    };
    this.isPanMode = function () {
        return this.moveMode === 'PAN';
    };
    this.isRotate = function () {
        return this.moveMode === 'ROTATE';
    };
    this.mouseMoveHandler = function (x, y) {
        if (!this.smallLoaded)
            return;
        if (this.isPanMode()) {

            this.currentPanMoveX = this.refMouseX - x;
            this.currentPanMoveY = this.refMouseY - y;
            this.displayCurrentImage();
            return;
        }

        var moveX = this.currentMoveX = this.refMouseX - x;
        var moveY = this.currentMoveY = this.refMouseY - y;

        this.moveObjectByXY(moveX, moveY);

        this.rememberInertiaStates();

    };

    this.moveObjectByXY = function (moveX, moveY) {


        if (moveX !== 0) {


            var dirX = -this.getDirection(moveX);

            var moveCols = Math.floor(Math.abs(moveX) / this.config.xAxisSensitivity);

            this.currentCol = (this.refCol + (dirX * moveCols)) % this.cols;

            this.currentCol = this.currentCol < 0 ? this.currentCol + this.cols : this.currentCol;

        }

        if (moveY !== 0) {
            var dirY = -this.getDirection(moveY);
            var moveRows = Math.floor(Math.abs(moveY) / this.config.yAxisSensitivity);
            this.currentRow = (this.refRow + (dirY * moveRows)); // % rows;
            this.currentRow = Math.min(this.rows - 1, this.currentRow);
            this.currentRow = Math.max(0, this.currentRow);
        }

        this.autoCol = this.currentCol;

        var idx = this.getIdxByColRow(this.currentCol, this.currentRow);
        this.displayImageByIdx(idx);

    };

    this.getIdxByColRow = function (currentCol, currentRow) {
        //if(this.config.opositeDirection == true) currentCol = this.cols - currentCol;
        return currentCol + currentRow * this.cols; // - 1;
    };

    this.getDirection = function (n) {
        return n >= 0 ? 1 : -1;
    };

    this.autoRotateFunc = function (autoRotateDir) {

        var dir = autoRotateDir ? autoRotateDir : this.config.autoRotateDirection;
        if (dir == 1) {
            if (this.autoCol == this.cols - 1)
                this.autoCol = -1;
            this.autoCol++;
        } else {
            if (this.autoCol == 0)
                this.autoCol = this.cols - 1;
            this.autoCol--;
        }

        this.currentCol = this.autoCol;
        var idx = this.getIdxByColRow(this.autoCol, this.currentRow);
        this.displayImageByIdx(idx);


        if (this.config.playBtnMode == "loop")
            return;
        if (!this._isPlayBtn)
            return;

        if (this.config.playBtnMode == "oneloop") {
            this._oneLoopCount++;
            if (this._oneLoopCount >= this.cols) {
                this.stopAutoRotate();
            }
        } else if (this.config.playBtnMode == "firstimage") {
            if (this.autoCol == 0) {
                this.stopAutoRotate();
            }
        } else if (this.config.playBtnMode == "lastimage") {
            if (this.autoCol == this.cols - 1) {
                this.stopAutoRotate();
            }
        } else if (parseInt(this.config.playBtnMode) == this.config.playBtnMode) {
            if (this.autoCol == parseInt(this.config.playBtnMode)) {
                this.stopAutoRotate();
            }
        }

    };

    this.setRow = function (row) {
        if (!this.smallLoaded)
            return;
        this.currentRow = row < this.config.rows ? row : row % this.config.rows;
        var idx = this.getIdxByColRow(this.currentCol, this.currentRow);
        this.displayImageByIdx(idx);
    };

    this.setColumn = function (col) {

        if (!this.smallLoaded)
            return;

        col = Math.abs(col) < this.config.columns ? col : col % this.config.columns;

        if (col < 0)
            col = this.config.columns + col;

        this.currentCol = col;

        var idx = this.getIdxByColRow(this.currentCol, this.currentRow);
        this.displayImageByIdx(idx);

    };

    this.minMax = function (n, min, max) {
        n = Math.min(n, max);
        n = Math.max(n, min);

        return n;
    };

    this.setVerticalAngle = function (a) {

        a = Math.abs(a);
        a = this.minMax(a, this.config.verticalAngles.from, this.config.verticalAngles.to);
        var pos = a - this.config.verticalAngles.from;
        var full = this.config.verticalAngles.to - this.config.verticalAngles.from;

        var proc = (pos / full) * 100;

        var r = Math.floor(this.config.rows * (proc / 100));
        r = Math.min(r, this.config.rows - 1);

        this.setRow(r);

    };

    this.displayCurrentImage = function () {
        if (this.latestImageIdx !== undefined) {
            this.displayImageByIdx(this.latestImageIdx);
        }
    };

    this._getFullSizeImageByIdx = function (idx) {
        // if(this.config.opositeDirection == true) idx = this.images.length - idx - 1;
        return this.fullSizeImages[idx];
    };

    this.displayImageByIdx = function (idx) {

        //if( this.latestImageIdx ==idx) return;

        this.latestImageIdx = idx;

        // if(this.config.opositeDirection == true) idx = this.images.length - idx - 1;

        var imgObj = this.images[idx];

        if (this.fullSizeImages && this.fullSizeImages[idx] && this.fullSizeImages[idx].complete) {
            var imgObj = this.fullSizeImages[idx];
        }

        this.displayImage(imgObj);

    };

    this.displayImage = function (imgObj, opacity) {

        this.latestImageObj = imgObj;
        this.fitImageOn(this.canvas, imgObj);
        //this._drawImage()

    };

    this.panMoveEmptyX = 0;
    this.panMoveEmptyY = 0;
    this.fitImageOn = function (canvas, iobj, skipClear) {

        var imageAspectRatio = iobj.width / iobj.height;
        var canvasAspectRatio = canvas.width / canvas.height;
        var renH, renW, xStart, yStart;

        if (imageAspectRatio > canvasAspectRatio) {
            if (this.config.fitmode == "left-right" || this.config.fitmode == "fit") {
                renW = canvas.width;
                renH = iobj.height * (renW / iobj.width);
                xStart = 0;
                yStart = (canvas.height - renH) / 2;
            } else {
                renH = canvas.height;
                renW = iobj.width * (renH / iobj.height);
                xStart = (canvas.width - renW) / 2;
                yStart = 0;

            }
        }
        else if (imageAspectRatio < canvasAspectRatio) {
            if (this.config.fitmode == "left-right") {
                renW = canvas.width;
                renH = iobj.height * (renW / iobj.width);
                xStart = 0;
                yStart = (canvas.height - renH) / 2;
            } else { // "top-bottom" || "fit"
                renH = canvas.height;
                renW = iobj.width * (renH / iobj.height);
                xStart = (canvas.width - renW) / 2;
                yStart = 0;
            }
        }
        else {
            renH = canvas.height;
            renW = canvas.width;
            xStart = 0;
            yStart = 0;
        }

        var zoomedRenW = renW * this.currentZoom;
        var zoomedRenH = renH * this.currentZoom;

        var zoomedXPos = xStart - (zoomedRenW - renW) / 2;
        var zoomedYPos = yStart - (zoomedRenH - renH) / 2;

        this.zoomedXPosCentered = zoomedXPos;
        this.zoomedYPosCentered = zoomedYPos;


        var fullscreenZoom = 1;

        zoomedXPos -= this.currentPanMoveX + ((this.globalPanMoveX || 0) * this.currentZoom * fullscreenZoom);
        zoomedYPos -= this.currentPanMoveY + ((this.globalPanMoveY || 0) * this.currentZoom * fullscreenZoom);

        this.zoomedXPosMoved = zoomedXPos;
        this.zoomedYPosMoved = zoomedYPos;

        if (this.zoomChanged) {
            this.zoomChanged = false;

            this.globalPanMoveX = -((this.zoomedXPosMoved - this.zoomedXPosCentered) / this.currentZoom);
            this.globalPanMoveY = -((this.zoomedYPosMoved - this.zoomedYPosCentered) / this.currentZoom);
        }

        var ctx = canvas.getContext("2d");
        if (!skipClear) {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
        }

        if (this.config.panInBounds) {
            if (zoomedXPos > 0) {
                this.panMoveEmptyX = zoomedXPos;
                zoomedXPos = 0;
            }
            if (zoomedYPos > 0) {
                this.panMoveEmptyY = zoomedYPos;
                zoomedYPos = 0;
            }


            if (zoomedRenW + zoomedXPos < this.canvas.width) {
                this.panMoveEmptyX = zoomedXPos;
                zoomedXPos = -(zoomedRenW - this.canvas.width);
                this.panMoveEmptyX -= zoomedXPos;
            }
            if (zoomedRenH + zoomedYPos < this.canvas.height) {
                this.panMoveEmptyY = zoomedYPos;
                zoomedYPos = -(zoomedRenH - this.canvas.height);
                this.panMoveEmptyY -= zoomedYPos;
            }

        }

        ctx.save();
        ctx.globalAlpha = this.config.opacity;
        ctx.drawImage(iobj, zoomedXPos, zoomedYPos, zoomedRenW, zoomedRenH);
        ctx.restore();
    }

    // mozfullscreenchange fullscreenchange
    this.addFullScreenEvents = function () {
        var self = this;
        V360Util.removeEvent(window, 'resize', this.resizeReset);
        V360Util.removeEvent(document.documentElement, 'fullscreenchange', this.fullscreenEnteredListener);
        V360Util.removeEvent(document, 'mozfullscreenchange', this.fullscreenEnteredListener);
        V360Util.removeEvent(document, 'MSFullscreenChange', this.fullscreenEnteredListener, false);
        V360Util.removeEvent(document.documentElement, 'webkitfullscreenchange', this.fullscreenEnteredListener);
        this.fullscreenEnteredListener = function () {
            self.isFullscreen = document.fullscreen || document.mozFullScreen || document.webkitIsFullScreen || document.msFullscreenElement;
            self.resizeReset();
            /*setTimeout(function(){
                self.resizeReset();
            },200);*/
        };
        V360Util.addEvent(window, 'resize', this.resizeReset, false);
        V360Util.addEvent(document.documentElement, 'fullscreenchange', this.fullscreenEnteredListener, false);
        V360Util.addEvent(document, 'mozfullscreenchange', this.fullscreenEnteredListener, false);
        V360Util.addEvent(document, 'MSFullscreenChange', this.fullscreenEnteredListener, false);
        V360Util.addEvent(document.documentElement, 'webkitfullscreenchange', this.fullscreenEnteredListener, false);
    };

    this.resizeReset = function () {
        var self = this;

        if (self.isFullscreen) {
            self.disableResponsive = true;
            self.latestRWidth = -1; //reset to pass arange
            var bodyElems = document.getElementsByTagName("body");
            var body = bodyElems[0];
            if(self.oldBodyOverflowX=="unset") {
                self.oldBodyOverflowX = body.style.overflowX;
                self.oldBodyOverflowY = body.style.overflowY;
            }

            //document.documentElement.style.overflowX = "hidden";
            //document.documentElement.style.overflowY = "hidden";
            body.style.overflowX = "hidden";
            body.style.overflowY = "hidden";

            self.innerHolder.className = "View360-holderFullscreen";
            document.body.appendChild(self.innerHolder);

            var fullscreenZoomX = self.canvas.width / window.innerWidth;
            var fullscreenZoomY = self.canvas.height / window.innerHeight;

            self.globalPanMoveX = -((self.zoomedXPosMoved - self.zoomedXPosCentered) / self.currentZoom) / fullscreenZoomX;
            self.globalPanMoveY = -((self.zoomedYPosMoved - self.zoomedYPosCentered) / self.currentZoom) / fullscreenZoomY;

            V360Util.setAttribute(self.canvas, "width", window.innerWidth);
            V360Util.setAttribute(self.canvas, "height", window.innerHeight);
            self.innerHolder.style.width = window.innerWidth + "px";
            self.innerHolder.style.height = window.innerHeight + "px";
            self.innerHolder.style.top = window.pageYOffset + "px";
            self.innerHolder.style.left = window.pageXOffset + "px";

            if (self.navigationConfig.showFullscreen && self.navigationConfig.showButtons) {
                V360Util.getFirstElementByClassName(self.innerHolder, "View360-navigationFullscreenEnter").style.display = "none";
                V360Util.getFirstElementByClassName(self.innerHolder, "View360-navigationFullscreenExit").style.display = "inline-block";
            }

            if (self.config.loadFullSizeImagesOnFullscreen) {
                self.startFullSizeImageLoader();
            }
        } else {
            self.disableResponsive = false;
            self.innerHolder.className = "View360-holder";
            self.holder.appendChild(self.innerHolder);

            var fullscreenZoomX = self.canvas.width / self.config.width;
            var fullscreenZoomY = self.canvas.height / self.config.height;

            self.globalPanMoveX = -((self.zoomedXPosMoved - self.zoomedXPosCentered) / self.currentZoom) / fullscreenZoomX;
            self.globalPanMoveY = -((self.zoomedYPosMoved - self.zoomedYPosCentered) / self.currentZoom) / fullscreenZoomY;

            this.updateCanvasSize();
            V360Util.setAttribute(self.canvas, "width", self.config.width);
            V360Util.setAttribute(self.canvas, "height", self.config.height);
            self.innerHolder.style.width = self.config.width + "px";

            self.innerHolder.style.height = self.config.height + "px";
            self.innerHolder.style.top = "0px";
            self.innerHolder.style.left = "0px";


            var bodyElems = document.getElementsByTagName("body");
            var body = bodyElems[0];
            //document.documentElement.style.overflowX = document.documentElement.style.overflowY = "auto"
            body.style.overflowX = self.oldBodyOverflowX;
            body.style.overflowY = self.oldBodyOverflowY;
            setTimeout(function(){
                body.style.overflowX = self.oldBodyOverflowX;
                body.style.overflowY = self.oldBodyOverflowY;
            }, 200)


            if (self.navigationConfig.showFullscreen && self.navigationConfig.showButtons) {
                V360Util.getFirstElementByClassName(self.innerHolder, "View360-navigationFullscreenEnter").style.display = "inline-block";
                V360Util.getFirstElementByClassName(self.innerHolder, "View360-navigationFullscreenExit").style.display = "none";
            }

        }

        if (self.latestImageIdx !== undefined) {
            self.displayImageByIdx(self.latestImageIdx);
        }
    };

    this.destroy = function () {
        V360Util.removeEvent(window, 'resize', this.resizeReset);
        V360Util.removeEvent(document.documentElement, 'fullscreenchange', this.fullscreenEnteredListener);
        V360Util.removeEvent(document, 'mozfullscreenchange', this.fullscreenEnteredListener);
        V360Util.removeEvent(document, 'MSFullscreenChange', this.fullscreenEnteredListener, false);
        V360Util.removeEvent(document.documentElement, 'webkitfullscreenchange', this.fullscreenEnteredListener);

        if (this.responsiveInterval) clearInterval(this.responsiveInterval);

        this.fullscreenEnteredListener = null;
        this.innerHolder = null;
        this.turnMeOnHolder = null;
        this.holder.innerHTML = "";
        this.holder = null;
    };

    this.addInterface = function () {
        this.holder.innerHTML = this.htmlTemplate;

        var navigationBarEL = V360Util.getFirstElementByClassName(this.holder, 'View360-navigation');
        this.addNavButtonsToDom(navigationBarEL);
        V360Util.addEvent(navigationBarEL, 'click', function (evt) { evt.stopPropagation(); }, false);

        if(this.config.mode.indexOf("lightbox")!=-1){
            this.addCloseToDom(V360Util.getFirstElementByClassName(this.holder, "View360-closeHolder"));
        }

        this.innerHolder = V360Util.getFirstElementByClassName(this.holder, "View360-holder");

        this.turnMeOnHolder = V360Util.getFirstElementByClassName(this.holder, "View360-turnMeOnHolder");
        this.turnMeOnHolder.style.display = "none";

        var el = V360Util.getFirstElementByClassName(this.innerHolder, "View360-navigationFullscreenExit");
        el.style.display = "none";

        var els = V360Util.getElementsByClassName(this.innerHolder, "View360-navigationBtn");

        for (var i = 0; i < els.length; i++) {
            if (this.navigationConfig.btnWidth) {
                els[i].style.width = this.navigationConfig.btnWidth + "px";
            }
            if (this.navigationConfig.btnHeight) {
                els[i].style.height = this.navigationConfig.btnHeight + "px";
            }

            if (this.navigationConfig.btnMargin !== undefined)
                els[i].style.marginLeft = this.navigationConfig.btnMargin + "px";
            if (this.navigationConfig.orientation == "vertical") {
                if (els[i].style.display != "none")
                    els[i].style.display = "block";
            }
        }
        var elNavigation = V360Util.getFirstElementByClassName(this.innerHolder, "View360-navigation");

        var elNavigationHolder = V360Util.getFirstElementByClassName(this.innerHolder, "View360-navigationHolder");

        elNavigation.style.textAlign = this.navigationConfig.align;

        if (this.navigationConfig.orientation == "vertical") {
            if (this.navigationConfig.align == "left") {
                elNavigationHolder.style.right = "auto";
            } else if (this.navigationConfig.align == "right") {
                elNavigationHolder.style.left = "auto";
            }
        }

        var self = this;
        this.bindBtn("View360-navigationFullscreenEnter", "click", function (evt) {
            var divObj = evt.target;

            V360Util.getFirstElementByClassName(self.innerHolder, "View360-navigationFullscreenEnter").style.display = "none";
            V360Util.getFirstElementByClassName(self.innerHolder, "View360-navigationFullscreenExit").style.display = "inline-block";

            self.addFullScreenEvents();

            var el = document.documentElement;
            var rfs = el.requestFullScreen
                || el.webkitRequestFullScreen
                || el.mozRequestFullScreen
                || el.msRequestFullscreen;

            var allowedFs = self.isAllowedFS();

            if (!rfs || !allowedFs) {
                self.isFullscreen = true;
                self.resizeReset();
            } else {
                rfs.call(el);
            }
        });

        this.bindBtn("View360-navigationFullscreenExit", "click", this.exitFullscreenBtnHandler.bind(this));
    };

         this.exitFullscreenBtnHandler = function () {
            V360Util.getFirstElementByClassName(this.innerHolder, "View360-navigationFullscreenEnter").style.display = "inline-block";
            V360Util.getFirstElementByClassName(this.innerHolder, "View360-navigationFullscreenExit").style.display = "none";

            this.addFullScreenEvents();

            var el = document;
            var rfs = el.exitFullscreen
                || el.webkitCancelFullScreen
                || el.webkitExitFullscreen
                || el.mozCancelFullScreen
                || el.msExitFullscreen;

            var allowedFs = this.isAllowedFS();

            if (!rfs || !allowedFs) {
                this.isFullscreen = false;
                this.resizeReset();
            } else {
                rfs.call(el);
            }
        };

    this.close = function () {
        clearInterval(this.rememberInertiaInterval);
        clearInterval(this.autoRotateInterval);
        clearInterval(this.responsiveInterval);
        clearInterval(this.inertiaAutoMoveInterval);

        this.holder.innerHTML = "";
    };

    this.isAllowedFS = function () {
        return document.fullscreenEnabled ||
            document.webkitFullscreenEnabled ||
            document.mozFullScreenEnabled ||
            document.msFullscreenEnabled;
    };

    this.bindBtn = function (className, event, handler) {
        var el = V360Util.getFirstElementByClassName(this.innerHolder, className);
        V360Util.addEvent(el, event, function (event) {
            handler(event);
        }, false);
    };

    this.bindEvents = function () {
        var self = this;

        this.clickableAreaObj = V360Util.getFirstElementByClassName(this.innerHolder, 'View360-clickableArea');

        //mousedown
        this.mouseDownHandlerListener = function (event) {
            event.preventDefault();
            self.mouseDownHandler(event.pageX, event.pageY);
        };
        V360Util.addEvent(this.clickableAreaObj, 'mousedown', this.mouseDownHandlerListener, false);
        V360Util.addEvent(this.clickableAreaObj, 'click', function (evt) {
            evt.stopPropagation();
        }, false);

        //touchstart
        this.touchStartHandlerListener = function (event) {
            self.mouseDownHandler(event.touches[0].pageX, event.touches[0].pageY);
        };
        V360Util.addEvent(this.clickableAreaObj, 'touchstart', this.touchStartHandlerListener, false);

        this.toggleClickableArea();
        this._setCliackableAreaClass();

        this.navigationHolder = V360Util.getFirstElementByClassName(this.innerHolder, 'View360-navigationHolder');
        // this.navigationHolder.style.display = "none";
        this.navigationHolder.style.visibility = 'hidden';

        if (!this.navigationConfig.showButtons) {
            return;
        }

        //TOOL ROTATE
        var rotateBtn = V360Util.getFirstElementByClassName(this.innerHolder, 'View360-navigationRotate');
        if (this.navigationConfig.showTool && this.navigationConfig.showRotate && this.navigationConfig.showButtons) {
            this.navigationHandHandlerListener = function() {
                self.setMoveMode('ROTATE');
            };
            this.navigationHandKeydownHandlerListener = function (event) {
                if (event.keyCode === 13) {
                    event.preventDefault();
                    this.navigationHandHandlerListener();
                }
            };
            V360Util.addEvent(rotateBtn, 'click', this.navigationHandHandlerListener, false);
            V360Util.addEvent(rotateBtn, 'keydown', this.navigationHandKeydownHandlerListener, false);
        } else {
            rotateBtn.style.display = 'none';
        }

        //TOOL HAND
        var handBtn = V360Util.getFirstElementByClassName(this.innerHolder, "View360-navigationHand");
        if (this.navigationConfig.showTool && this.navigationConfig.showMove && this.navigationConfig.showButtons) {
            this.navigationHandHandlerListener = function (event) {
                self.setMoveMode("PAN");
            };
            this.navigationHandKeydownHandlerListener = function (event) {
                if (event.keyCode === 13) {
                    event.preventDefault();
                    this.navigationHandHandlerListener();
                }
            };
            V360Util.addEvent(handBtn, "click", this.navigationHandHandlerListener, false);
            V360Util.addEvent(handBtn, "keydown", this.navigationHandKeydownHandlerListener, false);

        } else {
            handBtn.style.display = "none";
        }

        //PLAY
        var playBtn = V360Util.getFirstElementByClassName(this.innerHolder, "View360-navigationPlay");
        if (this.navigationConfig.showPlay && this.navigationConfig.showButtons) {
            this.navigationPlayHandlerListener = function (event) {
                self.startAutoRotate(undefined, undefined, true);
            };
            this.navigationPlayKeydownHandlerListener = function (event) {
                if (event.keyCode === 13) {
                    event.preventDefault();
                    this.navigationPlayHandlerListener();
                }
            };
            V360Util.addEvent(playBtn, "click", this.navigationPlayHandlerListener, false);
            V360Util.addEvent(playBtn, "keydown", this.navigationPlayKeydownHandlerListener, false);

        } else {
            playBtn.style.display = "none";
        }

        //PAUSE
        var pauseBtn = V360Util.getFirstElementByClassName(this.innerHolder, "View360-navigationPause");
        if (this.navigationConfig.showPause && this.navigationConfig.showButtons) {
            this.navigationPauseHandlerListener = function (event) {
                self.stopAutoRotate();
            };
            this.navigationPauseKeydownHandlerListener = function (event) {
                if (event.keyCode === 13) {
                    event.preventDefault();
                    this.navigationPauseHandlerListener();
                }
            };
            V360Util.addEvent(pauseBtn, "click", this.navigationPauseHandlerListener, false);
            V360Util.addEvent(pauseBtn, "keydown", this.navigationPauseKeydownHandlerListener, false);

        } else {
            pauseBtn.style.display = "none";
        }

        this.toggleZoomButtons();

        //TURN LEFT
        var turnLeftBtn = V360Util.getFirstElementByClassName(this.innerHolder, 'View360-navigationTurnLeft');
        if (this.navigationConfig.showTurn && this.navigationConfig.showButtons) {
            this.navigationTurnLeftMouseDownHandlerListener = function() {
                self.startAutoRotate(-1, self.navigationConfig.turnSpeed);
                V360Util.addEvent(document, 'mouseup', function () {
                    self.stopAutoRotate();
                }, false);
                V360Util.addEvent(document, 'touchend', function () {
                    self.stopAutoRotate();
                }, false);
            };
            this.navigationTurnLeftKeydownHandlerListener = function(event) {
                if (event.keyCode === 13) {
                    self.startAutoRotate(-1, self.navigationConfig.turnSpeed);
                    V360Util.addEvent(document, 'keyup', function (event) {
                        if (event.keyCode === 13) {
                            self.stopAutoRotate();
                        }
                    }, false);
                }
            };
            V360Util.addEvent(turnLeftBtn, 'mousedown', this.navigationTurnLeftMouseDownHandlerListener, false);
            V360Util.addEvent(turnLeftBtn, 'touchstart', this.navigationTurnLeftMouseDownHandlerListener, false);
            V360Util.addEvent(turnLeftBtn, 'keydown', this.navigationTurnLeftKeydownHandlerListener, false);
        } else {
            turnLeftBtn.style.display = 'none';
        }

        //TURN RIGHT
        var turnRightBtn = V360Util.getFirstElementByClassName(this.innerHolder, 'View360-navigationTurnRight');
        if (this.navigationConfig.showTurn && this.navigationConfig.showButtons) {
            this.navigationTurnLeftMouseDownHandlerListener = function() {
                self.startAutoRotate(1, self.navigationConfig.turnSpeed);
                V360Util.addEvent(document, 'mouseup', function () {
                    self.stopAutoRotate();
                }, false);
                V360Util.addEvent(document, 'touchend', function () {
                    self.stopAutoRotate();
                }, false);
            };
            this.navigationTurnLeftKeydownHandlerListener = function(event) {
                if (event.keyCode === 13) {
                    self.startAutoRotate(1, self.navigationConfig.turnSpeed);
                    V360Util.addEvent(document, 'keyup', function (event) {
                        if (event.keyCode === 13) {
                            self.stopAutoRotate();
                        }
                    }, false);
                }
            };
            V360Util.addEvent(turnRightBtn, 'mousedown', this.navigationTurnLeftMouseDownHandlerListener, false);
            V360Util.addEvent(turnRightBtn, 'touchstart', this.navigationTurnLeftMouseDownHandlerListener, false);
            V360Util.addEvent(turnRightBtn, 'keydown', this.navigationTurnLeftKeydownHandlerListener, false);
        } else {
            turnRightBtn.style.display = 'none';
        }

        //CLOSE LEFT
        var closeBtn = V360Util.getFirstElementByClassName(this.innerHolder, "View360-navigationClose");

        if(closeBtn){
            if (this.navigationConfig.showClose) {
                V360Util.addEvent(closeBtn, 'click', function (event) {
                    if(self.isFullscreen) self.exitFullscreenBtnHandler();
                    else if(self.lightbox) self.lightbox.close();
                }, false);
                V360Util.addEvent(closeBtn, 'keydown', function (event) {
                    if (event.keyCode === 13) {
                        if(self.isFullscreen) self.exitFullscreenBtnHandler();
                        else if(self.lightbox) self.lightbox.close();
                    }
                }, false);
            } else {
                closeBtn.style.display = 'none';
            }
        }

        if (!this.navigationConfig.showFullscreen || !this.navigationConfig.showButtons) {
            V360Util.getFirstElementByClassName(self.innerHolder, "View360-navigationFullscreenEnter").style.display = "none";
            V360Util.getFirstElementByClassName(self.innerHolder, "View360-navigationFullscreenExit").style.display = "none";
        }
    };

    this.toggleClickableArea = function(allowed) {
        if (allowed !== undefined && this.navigationConfig.clickableArea === allowed) {
            return;
        }

        if (allowed !== undefined) {
            this.navigationConfig.clickableArea = allowed;
        } else {
            allowed = this.navigationConfig.clickableArea;
        }

        if (allowed) {
            this.clickableAreaObj.style.display = '';
        } else {
            this.clickableAreaObj.style.display = 'none';
        }
    };

    this.toggleZoomButtons = function(show) {
        if (show !== undefined && this.navigationConfig.showZoom === show) {
            return;
        }

        var self = this;

        if (show !== undefined) {
            this.navigationConfig.showZoom = show;
        } else {
            show = this.navigationConfig.showZoom;
        }

        //ZOOM IN
        var zoomInBtn = V360Util.getFirstElementByClassName(this.innerHolder, 'View360-navigationZoomIn');
        if (show && this.navigationConfig.showButtons) {
            this.navigationZoomInHandlerListener = this.navigationZoomInHandlerListener || function() { self.zoomIn(); };
            this.navigationZoomInHandlerKeydownListener = function (event) {
                // Number 13 is the "Enter" key on the keyboard
                if (event.keyCode === 13) {
                    event.preventDefault();
                    self.navigationZoomInHandlerListener();
                }
            };
            V360Util.addEvent(zoomInBtn, 'click', this.navigationZoomInHandlerListener, false);
            V360Util.addEvent(zoomInBtn, 'keydown', this.navigationZoomInHandlerKeydownListener, false);
            zoomInBtn.style.display = '';
        } else {
            if (this.navigationZoomInHandlerListener) {
                V360Util.removeEvent(zoomInBtn, 'click', this.navigationZoomInHandlerListener);
                V360Util.removeEvent(zoomInBtn, 'keydown', this.navigationZoomInHandlerKeydownListener);
            }
            zoomInBtn.style.display = 'none';
        }

        //ZOOM OUT
        var zoomOutBtn = V360Util.getFirstElementByClassName(this.innerHolder, 'View360-navigationZoomOut');
        if (show && this.navigationConfig.showButtons) {
            this.navigationZoomOutHandlerListener = this.navigationZoomOutHandlerListener || function() { self.zoomOut(); };
            this.navigationZoomOutHandlerKeydownListener = function (event) {
                // Number 13 is the "Enter" key on the keyboard
                if (event.keyCode === 13) {
                    event.preventDefault();
                    self.navigationZoomOutHandlerListener();
                }
            };
            V360Util.addEvent(zoomOutBtn, 'click', this.navigationZoomOutHandlerListener, false);
            V360Util.addEvent(zoomOutBtn, 'keydown', this.navigationZoomOutHandlerKeydownListener, false);
            zoomOutBtn.style.display = '';
        } else {
            if (this.navigationZoomOutHandlerListener) {
                V360Util.removeEvent(zoomOutBtn, 'click', this.navigationZoomOutHandlerListener);
                V360Util.removeEvent(zoomOutBtn, 'keydown', this.navigationZoomOutHandlerKeydownListener);
            }
            zoomOutBtn.style.display = 'none';
        }
        if (this.config.zoomMultipliers.indexOf(this.currentZoom) === 0) {
            this._setZoomOutOpacity(0.5);
        }
    };

    // allow overriding the zoom in and zoom out events, when the sp event returns false the real event should not happen
    this._handleSpEvent = function(eventName, options) {
        var result = true;

        if (this.spEvents && this.spEvents[eventName] && typeof this.spEvents[eventName] === 'function') {
            result = this.spEvents[eventName](options);
        }

        result = result !== false && result !== 0;

        if (result) {
            this.displayImageByIdx(this.latestImageIdx);
        }

        return result;
    };

    this.zoomIn = function () {
        var chosenIndex;
        for (var i = 0; i < this.config.zoomMultipliers.length; i++) {
            if (this.config.zoomMultipliers[i] > this.currentZoom) {
                chosenIndex = i;
                break;
            }
        }

        if (chosenIndex !== undefined) {
            var skipZoom = chosenIndex === 1 && !this._handleSpEvent('minZoomIn', { zoomIndex: chosenIndex });

            if (!skipZoom) {
                this.setZoom(this.config.zoomMultipliers[chosenIndex]);

                if (this.navigationConfig.autoPan) {
                    this.setMoveMode('PAN');
                }

                if (chosenIndex === (this.config.zoomMultipliers.length - 1)) {
                    this._setZoomInOpacity(0.5);
                }
            }

            this._setZoomOutOpacity(1);
        }
    };

    this.zoomOut = function () {
        var chosenIndex;
        for (var i = this.config.zoomMultipliers.length - 1; i >= 0; i--) {
            if (this.config.zoomMultipliers[i] < this.currentZoom) {
                chosenIndex = i;
                break;
            }
        }

        if (chosenIndex !== undefined) {
            // levi's code to reset the image's position when resetting to zero zoom
            if (chosenIndex === 0 && this.navigationConfig.autoPan) {
                this.currentPanMoveX = 0;
                this.currentPanMoveY = 0;
                this.globalPanMoveX = 0;
                this.globalPanMoveY = 0;
            }

            this.setZoom(this.config.zoomMultipliers[chosenIndex]);

            if (chosenIndex === 0) {
                if (this.navigationConfig.autoPan) {
                    this.setMoveMode('ROTATE');
                }
            }

            this._setZoomInOpacity(1);
        }

        if ((chosenIndex === 0 || chosenIndex === undefined) && this._handleSpEvent('maxZoomOut', { zoomIndex: chosenIndex })) {
            this._setZoomOutOpacity(0.5);
        }
    };

    this.resetZoom = function() {
        this._setZoomOutOpacity(0.5);
        this._setZoomInOpacity(1);
        this.currentPanMoveX = 0;
        this.currentPanMoveY = 0;
        this.globalPanMoveX = 0;
        this.globalPanMoveY = 0;

        this.setZoom(this.config.zoomMultipliers[0]);

        if (this.navigationConfig.autoPan) {
            this.setMoveMode('ROTATE');
        }
    };

    this._setZoomInOpacity = function(opacity) {
        V360Util.getFirstElementByClassName(this.innerHolder, 'View360-navigationZoomIn').style.opacity = opacity;
    };

    this._setZoomOutOpacity = function(opacity) {
        if (this.navigationConfig.zoomOutEnabled) {
            return;
        }

        V360Util.getFirstElementByClassName(this.innerHolder, 'View360-navigationZoomOut').style.opacity = opacity;
    };

    this.setZoom = function (zoom, withoutRefresh) {
        this.currentZoom = zoom;

        if (!withoutRefresh)
            this.displayImageByIdx(this.latestImageIdx);

        this.zoomChanged = true;
        if (this.currentZoom !== 1) {
            if (this.config.loadFullSizeImagesOnZoom === true || this.currentZoom >= this.config.loadFullSizeImagesOnZoom) {
                this.startFullSizeImageLoader();
            }
        }
    };

    this.startFullSizeImageLoader = function () {
        if (!this.config.fullSizeImagesDirectory || this.config.fullSizeImagesDirectory == "") {
            return;
        }

        var self = this;

        if (!this.fullSizeLoaderInfo) {
            this.fullSizeLoaderInfo = new this.fullSizeLoaderInfoClass(V360Util.getFirstElementByClassName(this.innerHolder, "View360-fullSizeLoaderHolder"));
            this.fullSizeLoaderInfo.setConfig(this.fullSizeLoaderInfoConfig);

            var fullSizeLoader = new View360Loader();

            var callbackProgress = function (progressObj) {
                self.fullSizeLoaderInfo.setPercent(progressObj.percent);
            };

            var callbackOne = function (_image, isError, images) {
            };

            var callbackEach = function (_image, isError) {

                //if (_image == self.fullSizeImages[self.latestImageIdx]) {
                if (_image == self._getFullSizeImageByIdx(self.latestImageIdx)) {

                    self.displayCurrentImage();
                }

            };

            var callbackAll = function (_images, errorCount) {
                self.fullSizeLoaderInfo.hide();
                self.fullSizeImages = _images;
                self.displayCurrentImage();
            };


            fullSizeLoader.setCallbackOne(callbackOne);
            fullSizeLoader.setCallbackAll(callbackAll);
            fullSizeLoader.setCallbackEach(callbackEach);
            fullSizeLoader.setCallbackProgress(callbackProgress);
            fullSizeLoader.setSources(this.sources);
            fullSizeLoader.setDirectory(this.config.fullSizeImagesDirectory);
            fullSizeLoader.start();

            self.fullSizeImages = fullSizeLoader.getImages();

            this.fullSizeLoaderInfo.show();
        }
    };

    this.autoRotateInterval = null;
    this.startAutoRotate = function (direction, turnSpeed, isPlayBtn) {

        this._isPlayBtn = isPlayBtn;
        this._oneLoopCount = 0;

        turnSpeed = turnSpeed ? turnSpeed : this.config.autoRotateSpeed;

        this.stopAutoRotate();
        var self = this;
        this.autoRotateInterval = setInterval(function () {
            if (!self.autoRotatePaused)
                self.autoRotateFunc(direction);
        }, turnSpeed);


    };

    this.stopAutoRotate = function () {
        clearInterval(this.autoRotateInterval);
    };


    this.autoCreateImages = function () {

        if (!this.config.autoLoadImages)
            return;

        var p = this.config.imagesPattern;

        this.config.images = new Array();
        this.sources = new Array();
        for (var r = 0; r < this.config.rows; r++) {
            this.config.images[r] = new Array();
            for (var c = 0; c < this.config.columns; c++) {
                if (!this.config.images[c]) {
                    this.config.images[c] = new Array();
                }

                var __col = c;
                if (this.config.opositeDirection === true) __col = this.config.columns - c - 1;
                var __col = __col + this.config.imagesNumbering;


                var __row = r;
                if (this.config.opositeDirectionUpDown === true) __row = this.config.rows - r - 1;
                var __row = __row + this.config.imagesNumberingUpDown;

                var name = p.replace("%ROW", __row).replace("%COL", __col);

                var name = name.replace("%R%", V360Util.pad(__row, 1)).replace("%C%", V360Util.pad(__col, 1));
                var name = name.replace("%RR%", V360Util.pad(__row, 2)).replace("%CC%", V360Util.pad(__col, 2));
                var name = name.replace("%RRR%", V360Util.pad(__row, 3)).replace("%CCC%", V360Util.pad(__col, 3));

                this.config.images[c].push(name);

                this.sources.push(name);
            }
        }

    };

    this.calculate = function () {

        this.rows = 0;
        this.cols = 0;
        if (this.config.images instanceof Array) {
            if (this.config.images[0] && this.config.images[0] instanceof Array) {
                this.rows = this.config.images[0].length;
                this.cols = this.config.images.length;
            } else {
                this.rows = this.config.images.length;
                this.cols = 1;
            }
        }

        this.totalImages = this.rows * this.cols;

    };

    this.responsiveResize = function () {

        if(this.disableResponsive) return;

        if (this.responsiveConst) {
            var w = this.holder.offsetWidth;
            if (w == this.latestRWidth) {
                return;
            }

            var h = Math.round(w * this.responsiveConst);
            this.holder.style.height = h + "px";
            this.config.width = w;
            this.config.height = h;
            this.latestRWidth = w;
            this.updateCanvasSize();
            this.displayCurrentImage();
        }
    };

    this.responsiveFitResize = function () {

                if(this.disableResponsive) return;


        //if (this.responsiveConst) {
        var w = this.holder.offsetWidth;
        var h = this.holder.offsetHeight;

        if (w == this.latestRWidth && h == this.latestRHeight) {
            return;
        }

        //var h = Math.round(w * this.responsiveConst);
        //this.holder.style.height = h + "px";
        this.config.width = w;
        this.config.height = h;
        this.latestRWidth = w;
        this.latestRHeight = h;
        this.updateCanvasSize();
        this.displayCurrentImage();
        //}
    };

    this.resizeResponsiveByImage = function (imgObj) {
        var w = this.holder.offsetWidth;
        this.responsiveConst = (imgObj.height / imgObj.width);
        var h = Math.round(w * this.responsiveConst);
        this.holder.style.height = h + "px";
        this.config.height = h;
        this.updateCanvasSize();
    };

    this.resizeResponsiveFitByImage = function (imgObj) {
        var w = this.holder.offsetWidth;
        var h = this.holder.offsetHeight;

        // this.responsiveConst = (imgObj.height / imgObj.width);
        // var h = Math.round(w * this.responsiveConst);
        //this.holder.style.height = h + "px";
        //this.config.height = h;
        //this.config.height = w;
        this.updateCanvasSize();
    };

    this.updateCanvasSize = function () {


        V360Util.setAttribute(this.canvas, "width", this.config.width);
        V360Util.setAttribute(this.canvas, "height", this.config.height);

        this.canvasHolder.style.width = this.config.width + "px";
        this.canvasHolder.style.height = this.config.height + "px";

        this.innerHolder.style.width = this.config.width + "px";
        this.innerHolder.style.height = this.config.height + "px";

        if (this.latestImageIdx !== undefined) {
            this.displayImageByIdx(this.latestImageIdx);
        } else if (this.noOneImage !== undefined) {
            this.displayImage(this.noOneImage, this.config.firstImageOpacity);
        }

    };

    this.lightboxCloseHandler = function(){
        this.destroy();
    }

    this.responsiveInterval = null;
    this.currentZoom = 1;
    this.start = function (holder) {

        if(this.config.loaderShow){

            this.loaderInfoClass = View360LoadingInfo_New;
            this.fullSizeLoaderInfoClass = View360LoadingInfo_New;

            this.loaderInfoConfig.loaderShow = this.config.loaderShow;
            this.loaderInfoConfig.loaderColor = this.config.loaderColor;
            this.loaderInfoConfig.loaderClassname = this.config.loaderClassname;

        }

        var self = this;

        this.holder = holder;

        if (this.config.mode == "lightbox-responsive" || this.config.mode == "lightbox-css") {
            this.lightbox = new View360Lightbox();
            this.lightbox.closeCallback = this.lightboxCloseHandler.bind(this);
            this.lightbox.setConfig(this.config);

            this.holder = document.createElement("div");
            this.lightbox.setContent(this.holder);
            this.lightbox.open();
        }

        if (this.config.mode == "lightbox") {

            this.lightbox = new View360Lightbox();
            this.lightbox.closeCallback = this.lightboxCloseHandler.bind(this);
            this.lightbox.setConfig(this.config);
            this.holder = document.createElement("div");
            this.lightbox.setContent(this.holder);
            this.lightbox.open();

        } else if (this.config.mode == "fit") {

            this.config.width = this.holder.offsetWidth;
            this.config.height = this.holder.offsetHeight;

        } else if (this.config.mode == "fullscreen") {

            this.holder = document.createElement("div");
            this.holder.style.position = "fixed";
            this.holder.top = "0px";
            this.holder.left = "0px";

            document.body.appendChild(this.holder);
            this.config.width = window.innerWidth;
            this.config.height = window.innerHeight;

        } else if (this.config.mode == "responsive" || this.config.mode == "responsive-width" ) {

            clearInterval(this.responsiveInterval);
            //var self = this;
            this.responsiveInterval = setInterval(function () {
                self.responsiveResize();
            }, 500);

            this.config.width = this.holder.offsetWidth;
            this.config.height = this.holder.offsetHeight;

        } else if (this.config.mode == "responsive-fit" || this.config.mode == "lightbox-responsive"  || this.config.mode == "lightbox-css") {

            this.holder.style.top = "0px";
            this.holder.style.left = "0px";
            this.holder.style.bottom = "0px";
            this.holder.style.right = "0px";
            this.holder.style.position = "absolute";
            this.holder.style.overflow = "hidden";

            clearInterval(this.responsiveInterval);
            this.responsiveInterval = setInterval(function () {
                self.config.width = self.holder.offsetWidth;
                self.config.height = self.holder.offsetHeight;
                self.responsiveFitResize();
            }, 500);

            this.config.width = this.holder.offsetWidth;
            this.config.height = this.holder.offsetHeight;

        } else if (this.config.mode == "fixed") {
            //this.holder.style.width = this.config.width + "px";
            //this.holder.style.height = this.config.height + "px";
        }


        setTimeout(function () {
            self._timeout = true;
        }, 29 * 1000);


        this.currentZoom = 1;
        this.panMoveX = 0;
        this.panMoveY = 0;

        this.autoCreateImages();
        this.calculate();
        this.addInterface();
        this.bindEvents();


        self.smallLoaded = false;

        this.loaderInfo = new this.loaderInfoClass(V360Util.getFirstElementByClassName(this.innerHolder, "View360-loaderHolder"));
        this.loaderInfo.setConfig(this.loaderInfoConfig);
        this.loaderInfo.show();

        var sources = this.sources; // [].concat.apply( this.config.images )

        var canvas = this.canvas = V360Util.getFirstElementByClassName(this.innerHolder, "View360-canvas");
        var canvasHolder = this.canvasHolder = V360Util.getFirstElementByClassName(this.innerHolder, "View360-canvasHolder");

        self.updateCanvasSize();

        this.ctx = canvas.getContext("2d");

        var loader = new View360Loader();

        var callbackProgress = function (progressObj) {
            self.loaderInfo.setPercent(progressObj.percent);
        };

        var callbackOne = function (_image, isError) {

            if (!isError) {
                if (self.config.mode == "responsive" || self.config.mode == "responsive-width") {
                    self.resizeResponsiveByImage(_image);
                } else if (self.config.mode == "responsive-fit") {
                    self.resizeResponsiveFitByImage(_image);
                }
                self.displayImage(_image, 0.5);
                self.noOneImage = _image;

            }

        };

        var callbackAll = function (_images, errorCount) {

            self.smallLoaded = true;

            self.loaderInfo.hide();


            if (self.config.showTurnMeOn) {
                self.turnMeOnHolder.style.display = "block";
                //self.turnMeOnHolder.style.opacity = "1";
            }



            if (self.navigationConfig.showButtons) {
                //
                self.navigationHolder.style.visibility = "visible";
            } else {
                self.navigationHolder.style.display = "none";
            }

            self.images = _images;
            self.displayImageByIdx(self.config.initialImage);
            self.currentCol = self.config.initialImage;

            if (self.config.autoRotate)
                self.startAutoRotate();
            else if (self.config.oneTurnOnStartUp)
                self.startInertiaAutoMoveInterval(true);

        }

        loader.setCallbackOne(callbackOne, sources[this.config.initialImage]);
        loader.setCallbackAll(callbackAll);
        loader.setCallbackProgress(callbackProgress);
        loader.setSources(sources);
        loader.setDirectory(this.config.imagesDirectory);







        if (this.config.loadOnPageLoad) {

            if (this.config.loadFirstImage) loader.loadOne();

            if (document.readyState === 'complete') {
                loader.start();
            }
            else {
                var interval = setInterval(function () {
                    if (document.readyState === 'complete') {
                        clearInterval(interval);
                        if (!self.config.loadFirstImage) loader.loadOne();
                        loader.start();
                    }
                }, 200);
            }

        } else {
            loader.loadOne();
            loader.start();
        }

    };
    this.setConfig = function (config) {
        for (var name in config) {
            this.config[name] = config[name];
        }
    };
    this.setNavigationConfig = function (navigationConfig) {
        for (var name in navigationConfig) {
            this.navigationConfig[name] = navigationConfig[name];
        }
    };
    this.setProperty = function (name, prop) {
        this.config[name] = prop;
    };

    this.setMode = function (mode) {
        this.setProperty("mode", mode);
    };

    //v1.3.0
    this.setFitMode = function (fitmode) {
        this.setProperty("fitmode", fitmode);
    };
    this.setImagesPattern = function (imagesPattern) {
        this.setProperty("imagesPattern", imagesPattern);
    };

    this.setImagesDirectory = function (imagesDirectory) {
        this.setProperty("imagesDirectory", imagesDirectory);
    };

    this.setFullSizeImagesDirectory = function (fullSizeImagesDirectory) {
        this.setProperty("fullSizeImagesDirectory", fullSizeImagesDirectory);
    };

    this.setHtmlTemplate = function (htmlTemplate) {
        this.htmlTemplate = htmlTemplate;
    };

    this.setLoaderInfoClass = function (loaderInfoClass) {
        this.loaderInfoClass = loaderInfoClass;
    };

    this.setLoaderInfoConfig = function (loaderInfoConfig) {
        this.loaderInfoConfig = loaderInfoConfig;
    };

    this.setFullSizeLoaderInfoClass = function (fullSizeLoaderInfoClass) {
        this.fullSizeLoaderInfoClass = fullSizeLoaderInfoClass;
    };

    this.setFullSizeLoaderInfoConfig = function (fullSizeLoaderInfoConfig) {
        this.fullSizeLoaderInfoConfig = fullSizeLoaderInfoConfig;
    };

    this.setSpEvent = function (eventName, eventHandler) {
        this.spEvents = this.spEvents || {};
        this.spEvents[eventName] = eventHandler;
    };

    this.loadPreset = function (path) {
        var self = this;
        V360Util.loadJSON(path, function (jsonObj) {
            self.loaderInfoClass = View360LoadingInfo_New;
            self.fullSizeLoaderInfoClass = View360LoadingInfo_New;

            self.loaderInfoConfig.loaderShow = jsonObj.v360config.loaderShow;
            self.loaderInfoConfig.loaderColor = jsonObj.v360config.loaderColor;
            self.loaderInfoConfig.loaderClassname = jsonObj.v360config.loaderClassname;

            self.setConfig(jsonObj.v360config);
            self.setNavigationConfig(jsonObj.v360navigation);
            self.setImagesDirectory((self.consObj.basepath ? self.consObj.basepath + "ngdoc_assets/StateGoExamples.png'/>
     *
     * @param {string} to Absolute state name or relative state path. Some examples:
     *
     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
     * - `$state.go('^')` - will go to a parent state
     * - `$state.go('^.sibling')` - will go to a sibling state
     * - `$state.go('.child.grandchild')` - will go to grandchild state
     *
     * @param {object=} params A map of the parameters that will be sent to the state, 
     * will populate $stateParams. Any parameters that are not specified will be inherited from currently 
     * defined parameters. Only parameters specified in the state definition can be overridden, new 
     * parameters will be ignored. This allows, for example, going to a sibling state that shares parameters
     * specified in a parent state. Parameter inheritance only works between common ancestor states, I.e.
     * transitioning to a sibling will get you the parameters for all parents, transitioning to a child
     * will get you all current parameters, etc.
     * @param {object=} options Options object. The options are:
     *
     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
     * - **`reload`** (v0.2.5) - {boolean=false|string|object}, If `true` will force transition even if no state or params
     *    have changed.  It will reload the resolves and views of the current state and parent states.
     *    If `reload` is a string (or state object), the state object is fetched (by name, or object reference); and \
     *    the transition reloads the resolves and views for that matched state, and all its children states.
     *
     * @returns {promise} A promise representing the state of the new transition.
     *
     * Possible success values:
     *
     * - $state.current
     *
     * <br/>Possible rejection values:
     *
     * - 'transition superseded' - when a newer transition has been started after this one
     * - 'transition prevented' - when `event.preventDefault()` has been called in a `$stateChangeStart` listener
     * - 'transition aborted' - when `event.preventDefault()` has been called in a `$stateNotFound` listener or
     *   when a `$stateNotFound` `event.retry` promise errors.
     * - 'transition failed' - when a state has been unsuccessfully found after 2 tries.
     * - *resolve error* - when an error has occurred with a `resolve`
     *
     */
    $state.go = function go(to, params, options) {
      return $state.transitionTo(to, params, extend({ inherit: true, relative: $state.$current }, options));
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#transitionTo
     * @methodOf ui.router.state.$state
     *
     * @description
     * Low-level method for transitioning to a new state. {@link ui.router.state.$state#methods_go $state.go}
     * uses `transitionTo` internally. `$state.go` is recommended in most situations.
     *
     * @example
     * <pre>
     * var app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.transitionTo('contact.detail');
     *   };
     * });
     * </pre>
     *
     * @param {string} to State name.
     * @param {object=} toParams A map of the parameters that will be sent to the state,
     * will populate $stateParams.
     * @param {object=} options Options object. The options are:
     *
     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
     * - **`inherit`** - {boolean=false}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
     * - **`reload`** (v0.2.5) - {boolean=false|string=|object=}, If `true` will force transition even if the state or params 
     *    have not changed, aka a reload of the same state. It differs from reloadOnSearch because you'd
     *    use this when you want to force a reload when *everything* is the same, including search params.
     *    if String, then will reload the state with the name given in reload, and any children.
     *    if Object, then a stateObj is expected, will reload the state found in stateObj, and any children.
     *
     * @returns {promise} A promise representing the state of the new transition. See
     * {@link ui.router.state.$state#methods_go $state.go}.
     */
    $state.transitionTo = function transitionTo(to, toParams, options) {
      toParams = toParams || {};
      options = extend({
        location: true, inherit: false, relative: null, notify: true, reload: false, $retry: false
      }, options || {});

      var from = $state.$current, fromParams = $state.params, fromPath = from.path;
      var evt, toState = findState(to, options.relative);

      // Store the hash param for later (since it will be stripped out by various methods)
      var hash = toParams['#'];

      if (!isDefined(toState)) {
        var redirect = { to: to, toParams: toParams, options: options };
        var redirectResult = handleRedirect(redirect, from.self, fromParams, options);

        if (redirectResult) {
          return redirectResult;
        }

        // Always retry once if the $stateNotFound was not prevented
        // (handles either redirect changed or state lazy-definition)
        to = redirect.to;
        toParams = redirect.toParams;
        options = redirect.options;
        toState = findState(to, options.relative);

        if (!isDefined(toState)) {
          if (!options.relative) throw new Error("No such state '" + to + "'");
          throw new Error("Could not resolve '" + to + "' from state '" + options.relative + "'");
        }
      }
      if (toState[abstractKey]) throw new Error("Cannot transition to abstract state '" + to + "'");
      if (options.inherit) toParams = inheritParams($stateParams, toParams || {}, $state.$current, toState);
      if (!toState.params.$$validates(toParams)) return TransitionFailed;

      toParams = toState.params.$$values(toParams);
      to = toState;

      var toPath = to.path;

      // Starting from the root of the path, keep all levels that haven't changed
      var keep = 0, state = toPath[keep], locals = root.locals, toLocals = [];

      if (!options.reload) {
        while (state && state === fromPath[keep] && state.ownParams.$$equals(toParams, fromParams)) {
          locals = toLocals[keep] = state.locals;
          keep++;
          state = toPath[keep];
        }
      } else if (isString(options.reload) || isObject(options.reload)) {
        if (isObject(options.reload) && !options.reload.name) {
          throw new Error('Invalid reload state object');
        }
        
        var reloadState = options.reload === true ? fromPath[0] : findState(options.reload);
        if (options.reload && !reloadState) {
          throw new Error("No such reload state '" + (isString(options.reload) ? options.reload : options.reload.name) + "'");
        }

        while (state && state === fromPath[keep] && state !== reloadState) {
          locals = toLocals[keep] = state.locals;
          keep++;
          state = toPath[keep];
        }
      }

      // If we're going to the same state and all locals are kept, we've got nothing to do.
      // But clear 'transition', as we still want to cancel any other pending transitions.
      // TODO: We may not want to bump 'transition' if we're called from a location change
      // that we've initiated ourselves, because we might accidentally abort a legitimate
      // transition initiated from code?
      if (shouldSkipReload(to, toParams, from, fromParams, locals, options)) {
        if (hash) toParams['#'] = hash;
        $state.params = toParams;
        copy($state.params, $stateParams);
        copy(filterByKeys(to.params.$$keys(), $stateParams), to.locals.globals.$stateParams);
        if (options.location && to.navigable && to.navigable.url) {
          $urlRouter.push(to.navigable.url, toParams, {
            $$avoidResync: true, replace: options.location === 'replace'
          });
          $urlRouter.update(true);
        }
        $state.transition = null;
        return $q.when($state.current);
      }

      // Filter parameters before we pass them to event handlers etc.
      toParams = filterByKeys(to.params.$$keys(), toParams || {});
      
      // Re-add the saved hash before we start returning things or broadcasting $stateChangeStart
      if (hash) toParams['#'] = hash;
      
      // Broadcast start event and cancel the transition if requested
      if (options.notify) {
        /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeStart
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired when the state transition **begins**. You can use `event.preventDefault()`
         * to prevent the transition from happening and then the transition promise will be
         * rejected with a `'transition prevented'` value.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         *
         * @example
         *
         * <pre>
         * $rootScope.$on('$stateChangeStart',
         * function(event, toState, toParams, fromState, fromParams){
         *     event.preventDefault();
         *     // transitionTo() promise will be rejected with
         *     // a 'transition prevented' error
         * })
         * </pre>
         */
        if ($rootScope.$broadcast('$stateChangeStart', to.self, toParams, from.self, fromParams, options).defaultPrevented) {
          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
          //Don't update and resync url if there's been a new transition started. see issue #2238, #600
          if ($state.transition == null) $urlRouter.update();
          return TransitionPrevented;
        }
      }

      // Resolve locals for the remaining states, but don't update any global state just
      // yet -- if anything fails to resolve the current state needs to remain untouched.
      // We also set up an inheritance chain for the locals here. This allows the view directive
      // to quickly look up the correct definition for each view in the current state. Even
      // though we create the locals object itself outside resolveState(), it is initially
      // empty and gets filled asynchronously. We need to keep track of the promise for the
      // (fully resolved) current locals, and pass this down the chain.
      var resolved = $q.when(locals);

      for (var l = keep; l < toPath.length; l++, state = toPath[l]) {
        locals = toLocals[l] = inherit(locals);
        resolved = resolveState(state, toParams, state === to, resolved, locals, options);
      }

      // Once everything is resolved, we are ready to perform the actual transition
      // and return a promise for the new state. We also keep track of what the
      // current promise is, so that we can detect overlapping transitions and
      // keep only the outcome of the last transition.
      var transition = $state.transition = resolved.then(function () {
        var l, entering, exiting;

        if ($state.transition !== transition) {
          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
          return TransitionSuperseded;
        }

        // Exit 'from' states not kept
        for (l = fromPath.length - 1; l >= keep; l--) {
          exiting = fromPath[l];
          if (exiting.self.onExit) {
            $injector.invoke(exiting.self.onExit, exiting.self, exiting.locals.globals);
          }
          exiting.locals = null;
        }

        // Enter 'to' states not kept
        for (l = keep; l < toPath.length; l++) {
          entering = toPath[l];
          entering.locals = toLocals[l];
          if (entering.self.onEnter) {
            $injector.invoke(entering.self.onEnter, entering.self, entering.locals.globals);
          }
        }

        // Run it again, to catch any transitions in callbacks
        if ($state.transition !== transition) {
          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
          return TransitionSuperseded;
        }

        // Update globals in $state
        $state.$current = to;
        $state.current = to.self;
        $state.params = toParams;
        copy($state.params, $stateParams);
        $state.transition = null;

        if (options.location && to.navigable) {
          $urlRouter.push(to.navigable.url, to.navigable.locals.globals.$stateParams, {
            $$avoidResync: true, replace: options.location === 'replace'
          });
        }

        if (options.notify) {
        /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeSuccess
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired once the state transition is **complete**.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         */
          $rootScope.$broadcast('$stateChangeSuccess', to.self, toParams, from.self, fromParams);
        }
        $urlRouter.update(true);

        return $state.current;
      }).then(null, function (error) {
        // propagate TransitionSuperseded error without emitting $stateChangeCancel
        // as it was already emitted in the success handler above
        if (error === TransitionSupersededError) return TransitionSuperseded;

        if ($state.transition !== transition) {
          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
          return TransitionSuperseded;
        }

        $state.transition = null;
        /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeError
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired when an **error occurs** during transition. It's important to note that if you
         * have any errors in your resolve functions (javascript errors, non-existent services, etc)
         * they will not throw traditionally. You must listen for this $stateChangeError event to
         * catch **ALL** errors.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         * @param {Error} error The resolve error object.
         */
        evt = $rootScope.$broadcast('$stateChangeError', to.self, toParams, from.self, fromParams, error);

        if (!evt.defaultPrevented) {
          $urlRouter.update();
        }

        return $q.reject(error);
      });

      silenceUncaughtInPromise(transition);
      return transition;
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#is
     * @methodOf ui.router.state.$state
     *
     * @description
     * Similar to {@link ui.router.state.$state#methods_includes $state.includes},
     * but only checks for the full state name. If params is supplied then it will be
     * tested for strict equality against the current active params object, so all params
     * must match with none missing and no extras.
     *
     * @example
     * <pre>
     * $state.$current.name = 'contacts.details.item';
     *
     * // absolute name
     * $state.is('contact.details.item'); // returns true
     * $state.is(contactDetailItemStateObject); // returns true
     *
     * // relative name (. and ^), typically from a template
     * // E.g. from the 'contacts.details' template
     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
     * </pre>
     *
     * @param {string|object} stateOrName The state name (absolute or relative) or state object you'd like to check.
     * @param {object=} params A param object, e.g. `{sectionId: section.id}`, that you'd like
     * to test against the current active state.
     * @param {object=} options An options object.  The options are:
     *
     * - **`relative`** - {string|object} -  If `stateOrName` is a relative state name and `options.relative` is set, .is will
     * test relative to `options.relative` state (or name).
     *
     * @returns {boolean} Returns true if it is the state.
     */
    $state.is = function is(stateOrName, params, options) {
      options = extend({ relative: $state.$current }, options || {});
      var state = findState(stateOrName, options.relative);

      if (!isDefined(state)) { return undefined; }
      if ($state.$current !== state) { return false; }

      return !params || objectKeys(params).reduce(function(acc, key) {
        var paramDef = state.params[key];
        return acc && !paramDef || paramDef.type.equals($stateParams[key], params[key]);
      }, true);
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#includes
     * @methodOf ui.router.state.$state
     *
     * @description
     * A method to determine if the current active state is equal to or is the child of the
     * state stateName. If any params are passed then they will be tested for a match as well.
     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
     *
     * @example
     * Partial and relative names
     * <pre>
     * $state.$current.name = 'contacts.details.item';
     *
     * // Using partial names
     * $state.includes("contacts"); // returns true
     * $state.includes("contacts.details"); // returns true
     * $state.includes("contacts.details.item"); // returns true
     * $state.includes("contacts.list"); // returns false
     * $state.includes("about"); // returns false
     *
     * // Using relative names (. and ^), typically from a template
     * // E.g. from the 'contacts.details' template
     * <div ng-class="{highlighted: $state.includes('.item')}">Item</div>
     * </pre>
     *
     * Basic globbing patterns
     * <pre>
     * $state.$current.name = 'contacts.details.item.url';
     *
     * $state.includes("*.details.*.*"); // returns true
     * $state.includes("*.details.**"); // returns true
     * $state.includes("**.item.**"); // returns true
     * $state.includes("*.details.item.url"); // returns true
     * $state.includes("*.details.*.url"); // returns true
     * $state.includes("*.details.*"); // returns false
     * $state.includes("item.**"); // returns false
     * </pre>
     *
     * @param {string} stateOrName A partial name, relative name, or glob pattern
     * to be searched for within the current state name.
     * @param {object=} params A param object, e.g. `{sectionId: section.id}`,
     * that you'd like to test against the current active state.
     * @param {object=} options An options object.  The options are:
     *
     * - **`relative`** - {string|object=} -  If `stateOrName` is a relative state reference and `options.relative` is set,
     * .includes will test relative to `options.relative` state (or name).
     *
     * @returns {boolean} Returns true if it does include the state
     */
    $state.includes = function includes(stateOrName, params, options) {
      options = extend({ relative: $state.$current }, options || {});
      if (isString(stateOrName) && isGlob(stateOrName)) {
        if (!doesStateMatchGlob(stateOrName)) {
          return false;
        }
        stateOrName = $state.$current.name;
      }

      var state = findState(stateOrName, options.relative);
      if (!isDefined(state)) { return undefined; }
      if (!isDefined($state.$current.includes[state.name])) { return false; }
      if (!params) { return true; }

      var keys = objectKeys(params);
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i], paramDef = state.params[key];
        if (paramDef && !paramDef.type.equals($stateParams[key], params[key])) {
          return false;
        }
      }

      return objectKeys(params).reduce(function(acc, key) {
        var paramDef = state.params[key];
        return acc && !paramDef || paramDef.type.equals($stateParams[key], params[key]);
      }, true);
    };


    /**
     * @ngdoc function
     * @name ui.router.state.$state#href
     * @methodOf ui.router.state.$state
     *
     * @description
     * A url generation method that returns the compiled url for the given state populated with the given params.
     *
     * @example
     * <pre>
     * expect($state.href("about.person", { person: "bob" })).toEqual("renderer');
var LinearGradientContainer = _dereq_('../lineargradientcontainer');
var log = _dereq_('../log');

function CanvasRenderer(width, height) {
    Renderer.apply(this, arguments);
    this.canvas = this.options.canvas || this.document.createElement("canvas");
    if (!this.options.canvas) {
        this.canvas.width = width;
        this.canvas.height = height;
    }
    this.ctx = this.canvas.getContext("2d");
    this.taintCtx = this.document.createElement("canvas").getContext("2d");
    this.ctx.textBaseline = "bottom";
    this.variables = {};
    log("Initialized CanvasRenderer with size", width, "x", height);
}

CanvasRenderer.prototype = Object.create(Renderer.prototype);

CanvasRenderer.prototype.setFillStyle = function(fillStyle) {
    this.ctx.fillStyle = typeof(fillStyle) === "object" && !!fillStyle.isColor ? fillStyle.toString() : fillStyle;
    return this.ctx;
};

CanvasRenderer.prototype.rectangle = function(left, top, width, height, color) {
    this.setFillStyle(color).fillRect(left, top, width, height);
};

CanvasRenderer.prototype.circle = function(left, top, size, color) {
    this.setFillStyle(color);
    this.ctx.beginPath();
    this.ctx.arc(left + size / 2, top + size / 2, size / 2, 0, Math.PI*2, true);
    this.ctx.closePath();
    this.ctx.fill();
};

CanvasRenderer.prototype.circleStroke = function(left, top, size, color, stroke, strokeColor) {
    this.circle(left, top, size, color);
    this.ctx.strokeStyle = strokeColor.toString();
    this.ctx.stroke();
};

CanvasRenderer.prototype.drawShape = function(shape, color) {
    this.shape(shape);
    this.setFillStyle(color).fill();
};

CanvasRenderer.prototype.taints = function(imageContainer) {
    if (imageContainer.tainted === null) {
        this.taintCtx.drawImage(imageContainer.image, 0, 0);
        try {
            this.taintCtx.getImageData(0, 0, 1, 1);
            imageContainer.tainted = false;
        } catch(e) {
            this.taintCtx = document.createElement("canvas").getContext("2d");
            imageContainer.tainted = true;
        }
    }

    return imageContainer.tainted;
};

CanvasRenderer.prototype.drawImage = function(imageContainer, sx, sy, sw, sh, dx, dy, dw, dh) {
    if (!this.taints(imageContainer) || this.options.allowTaint) {
        this.ctx.drawImage(imageContainer.image, sx, sy, sw, sh, dx, dy, dw, dh);
    }
};

CanvasRenderer.prototype.clip = function(shapes, callback, context) {
    this.ctx.save();
    shapes.filter(hasEntries).forEach(function(shape) {
        this.shape(shape).clip();
    }, this);
    callback.call(context);
    this.ctx.restore();
};

CanvasRenderer.prototype.shape = function(shape) {
    this.ctx.beginPath();
    shape.forEach(function(point, index) {
        if (point[0] === "rect") {
            this.ctx.rect.apply(this.ctx, point.slice(1));
        } else {
            this.ctx[(index === 0) ? "moveTo" : point[0] + "To" ].apply(this.ctx, point.slice(1));
        }
    }, this);
    this.ctx.closePath();
    return this.ctx;
};

CanvasRenderer.prototype.font = function(color, style, variant, weight, size, family) {
    this.setFillStyle(color).font = [style, variant, weight, size, family].join(" ").split(",")[0];
};

CanvasRenderer.prototype.fontShadow = function(color, offsetX, offsetY, blur) {
    this.setVariable("shadowColor", color.toString())
        .setVariable("shadowOffsetY", offsetX)
        .setVariable("shadowOffsetX", offsetY)
        .setVariable("shadowBlur", blur);
};

CanvasRenderer.prototype.clearShadow = function() {
    this.setVariable("shadowColor", "rgba(0,0,0,0)");
};

CanvasRenderer.prototype.setOpacity = function(opacity) {
    this.ctx.globalAlpha = opacity;
};

CanvasRenderer.prototype.setTransform = function(transform) {
    this.ctx.translate(transform.origin[0], transform.origin[1]);
    this.ctx.transform.apply(this.ctx, transform.matrix);
    this.ctx.translate(-transform.origin[0], -transform.origin[1]);
};

CanvasRenderer.prototype.setVariable = function(property, value) {
    if (this.variables[property] !== value) {
        this.variables[property] = this.ctx[property] = value;
    }

    return this;
};

CanvasRenderer.prototype.text = function(text, left, bottom) {
    this.ctx.fillText(text, left, bottom);
};

CanvasRenderer.prototype.backgroundRepeatShape = function(imageContainer, backgroundPosition, size, bounds, left, top, width, height, borderData) {
    var shape = [
        ["line", Math.round(left), Math.round(top)],
        ["line", Math.round(left + width), Math.round(top)],
        ["line", Math.round(left + width), Math.round(height + top)],
        ["line", Math.round(left), Math.round(height + top)]
    ];
    this.clip([shape], function() {
        this.renderBackgroundRepeat(imageContainer, backgroundPosition, size, bounds, borderData[3], borderData[0]);
    }, this);
};

CanvasRenderer.prototype.renderBackgroundRepeat = function(imageContainer, backgroundPosition, size, bounds, borderLeft, borderTop) {
    var offsetX = Math.round(bounds.left + backgroundPosition.left + borderLeft), offsetY = Math.round(bounds.top + backgroundPosition.top + borderTop);
    this.setFillStyle(this.ctx.createPattern(this.resizeImage(imageContainer, size), "repeat"));
    this.ctx.translate(offsetX, offsetY);
    this.ctx.fill();
    this.ctx.translate(-offsetX, -offsetY);
};

CanvasRenderer.prototype.renderBackgroundGradient = function(gradientImage, bounds) {
    if (gradientImage instanceof LinearGradientContainer) {
        var gradient = this.ctx.createLinearGradient(
            bounds.left + bounds.width * gradientImage.x0,
            bounds.top + bounds.height * gradientImage.y0,
            bounds.left +  bounds.width * gradientImage.x1,
            bounds.top +  bounds.height * gradientImage.y1);
        gradientImage.colorStops.forEach(function(colorStop) {
            gradient.addColorStop(colorStop.stop, colorStop.color.toString());
        });
        this.rectangle(bounds.left, bounds.top, bounds.width, bounds.height, gradient);
    }
};

CanvasRenderer.prototype.resizeImage = function(imageContainer, size) {
    var image = imageContainer.image;
    if(image.width === size.width && image.height === size.height) {
        return image;
    }

    var ctx, canvas = document.createElement('canvas');
    canvas.width = size.width;
    canvas.height = size.height;
    ctx = canvas.getContext("2d");
    ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, size.width, size.height );
    return canvas;
};

function hasEntries(array) {
    return array.length > 0;
}

module.exports = CanvasRenderer;

},{"../lineargradientcontainer":12,"../log":13,"../renderer":19}],21:[function(_dereq_,module,exports){
var NodeContainer = _dereq_('./nodecontainer');

function StackingContext(hasOwnStacking, opacity, element, parent) {
    NodeContainer.call(this, element, parent);
    this.ownStacking = hasOwnStacking;
    this.contexts = [];
    this.children = [];
    this.opacity = (this.parent ? this.parent.stack.opacity : 1) * opacity;
}

StackingContext.prototype = Object.create(NodeContainer.prototype);

StackingContext.prototype.getParentStack = function(context) {
    var parentStack = (this.parent) ? this.parent.stack : null;
    return parentStack ? (parentStack.ownStacking ? parentStack : parentStack.getParentStack(context)) : context.stack;
};

module.exports = StackingContext;

},{"./nodecontainer":14}],22:[function(_dereq_,module,exports){
function Support(document) {
    this.rangeBounds = this.testRangeBounds(document);
    this.cors = this.testCORS();
    this.svg = this.testSVG();
}

Support.prototype.testRangeBounds = function(document) {
    var range, testElement, rangeBounds, rangeHeight, support = false;

    if (document.createRange) {
        range = document.createRange();
        if (range.getBoundingClientRect) {
            testElement = document.createElement('boundtest');
            testElement.style.height = "123px";
            testElement.style.display = "block";
            document.body.appendChild(testElement);

            range.selectNode(testElement);
            rangeBounds = range.getBoundingClientRect();
            rangeHeight = rangeBounds.height;

            if (rangeHeight === 123) {
                support = true;
            }
            document.body.removeChild(testElement);
        }
    }

    return support;
};

Support.prototype.testCORS = function() {
    return typeof((new Image()).crossOrigin) !== "undefined";
};

Support.prototype.testSVG = function() {
    var img = new Image();
    var canvas = document.createElement("canvas");
    var ctx =  canvas.getContext("2d");
    img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";

    try {
        ctx.drawImage(img, 0, 0);
        canvas.toDataURL();
    } catch(e) {
        return false;
    }
    return true;
};

module.exports = Support;

},{}],23:[function(_dereq_,module,exports){
var XHR = _dereq_('./xhr');
var decode64 = _dereq_('./utils').decode64;

function SVGContainer(src) {
    this.src = src;
    this.image = null;
    var self = this;

    this.promise = this.hasFabric().then(function() {
        return (self.isInline(src) ? Promise.resolve(self.inlineFormatting(src)) : XHR(src));
    }).then(function(svg) {
        return new Promise(function(resolve) {
            window.html2canvas.svg.fabric.loadSVGFromString(svg, self.createCanvas.call(self, resolve));
        });
    });
}

SVGContainer.prototype.hasFabric = function() {
    return !window.html2canvas.svg || !window.html2canvas.svg.fabric ? Promise.reject(new Error("html2canvas.svg.js is not loaded, cannot render svg")) : Promise.resolve();
};

SVGContainer.prototype.inlineFormatting = function(src) {
    return (/^data:image\/svg\+xml;base64,/.test(src)) ? this.decode64(this.removeContentType(src)) : this.removeContentType(src);
};

SVGContainer.prototype.removeContentType = function(src) {
    return src.replace(/^data:image\/svg\+xml(;base64)?,/,'');
};

SVGContainer.prototype.isInline = function(src) {
    return (/^data:image\/svg\+xml/i.test(src));
};

SVGContainer.prototype.createCanvas = function(resolve) {
    var self = this;
    return function (objects, options) {
        var canvas = new window.html2canvas.svg.fabric.StaticCanvas('c');
        self.image = canvas.lowerCanvasEl;
        canvas
            .setWidth(options.width)
            .setHeight(options.height)
            .add(window.html2canvas.svg.fabric.util.groupSVGElements(objects, options))
            .renderAll();
        resolve(canvas.lowerCanvasEl);
    };
};

SVGContainer.prototype.decode64 = function(str) {
    return (typeof(window.atob) === "function") ? window.atob(str) : decode64(str);
};

module.exports = SVGContainer;

},{"./utils":26,"./xhr":28}],24:[function(_dereq_,module,exports){
var SVGContainer = _dereq_('./svgcontainer');

function SVGNodeContainer(node, _native) {
    this.src = node;
    this.image = null;
    var self = this;

    this.promise = _native ? new Promise(function(resolve, reject) {
        self.image = new Image();
        self.image.onload = resolve;
        self.image.onerror = reject;
        self.image.src = "data:image/svg+xml," + (new XMLSerializer()).serializeToString(node);
        if (self.image.complete === true) {
            resolve(self.image);
        }
    }) : this.hasFabric().then(function() {
        return new Promise(function(resolve) {
            window.html2canvas.svg.fabric.parseSVGDocument(node, self.createCanvas.call(self, resolve));
        });
    });
}

SVGNodeContainer.prototype = Object.create(SVGContainer.prototype);

module.exports = SVGNodeContainer;

},{"./svgcontainer":23}],25:[function(_dereq_,module,exports){
var NodeContainer = _dereq_('./nodecontainer');

function TextContainer(node, parent) {
    NodeContainer.call(this, node, parent);
}

TextContainer.prototype = Object.create(NodeContainer.prototype);

TextContainer.prototype.applyTextTransform = function() {
    this.node.data = this.transform(this.parent.css("textTransform"));
};

TextContainer.prototype.transform = function(transform) {
    var text = this.node.data;
    switch(transform){
        case "lowercase":
            return text.toLowerCase();
        case "capitalize":
            return text.replace(/(^|\s|:|-|\(|\))([a-z])/g, capitalize);
        case "uppercase":
            return text.toUpperCase();
        default:
            return text;
    }
};

function capitalize(m, p1, p2) {
    if (m.length > 0) {
        return p1 + p2.toUpperCase();
    }
}

module.exports = TextContainer;

},{"./nodecontainer":14}],26:[function(_dereq_,module,exports){
exports.smallImage = function smallImage() {
    return "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
};

exports.bind = function(callback, context) {
    return function() {
        return callback.apply(context, arguments);
    };
};

/*
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */

exports.decode64 = function(base64) {
    var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    var len = base64.length, i, encoded1, encoded2, encoded3, encoded4, byte1, byte2, byte3;

    var output = "";

    for (i = 0; i < len; i+=4) {
        encoded1 = chars.indexOf(base64[i]);
        encoded2 = chars.indexOf(base64[i+1]);
        encoded3 = chars.indexOf(base64[i+2]);
        encoded4 = chars.indexOf(base64[i+3]);

        byte1 = (encoded1 << 2) | (encoded2 >> 4);
        byte2 = ((encoded2 & 15) << 4) | (encoded3 >> 2);
        byte3 = ((encoded3 & 3) << 6) | encoded4;
        if (encoded3 === 64) {
            output += String.fromCharCode(byte1);
        } else if (encoded4 === 64 || encoded4 === -1) {
            output += String.fromCharCode(byte1, byte2);
        } else{
            output += String.fromCharCode(byte1, byte2, byte3);
        }
    }

    return output;
};

exports.getBounds = function(node) {
    if (node.getBoundingClientRect) {
        var clientRect = node.getBoundingClientRect();
        var width = node.offsetWidth == null ? clientRect.width : node.offsetWidth;
        return {
            top: clientRect.top,
            bottom: clientRect.bottom || (clientRect.top + clientRect.height),
            right: clientRect.left + width,
            left: clientRect.left,
            width:  width,
            height: node.offsetHeight == null ? clientRect.height : node.offsetHeight
        };
    }
    return {};
};

exports.offsetBounds = function(node) {
    var parent = node.offsetParent ? exports.offsetBounds(node.offsetParent) : {top: 0, left: 0};

    return {
        top: node.offsetTop + parent.top,
        bottom: node.offsetTop + node.offsetHeight + parent.top,
        right: node.offsetLeft + parent.left + node.offsetWidth,
        left: node.offsetLeft + parent.left,
        width: node.offsetWidth,
        height: node.offsetHeight
    };
};

exports.parseBackgrounds = function(backgroundImage) {
    var whitespace = ' \r\n\t',
        method, definition, prefix, prefix_i, block, results = [],
        mode = 0, numParen = 0, quote, args;
    var appendResult = function() {
        if(method) {
            if (definition.substr(0, 1) === '"') {
                definition = definition.substr(1, definition.length - 2);
            }
            if (definition) {
                args.push(definition);
            }
            if (method.substr(0, 1) === '-' && (prefix_i = method.indexOf('-', 1 ) + 1) > 0) {
                prefix = method.substr(0, prefix_i);
                method = method.substr(prefix_i);
            }
            results.push({
                prefix: prefix,
                method: method.toLowerCase(),
                value: block,
                args: args,
                image: null
            });
        }
        args = [];
        method = prefix = definition = block = '';
    };
    args = [];
    method = prefix = definition = block = '';
    backgroundImage.split("").forEach(function(c) {
        if (mode === 0 && whitespace.indexOf(c) > -1) {
            return;
        }
        switch(c) {
        case '"':
            if(!quote) {
                quote = c;
            } else if(quote === c) {
                quote = null;
            }
            break;
        case '(':
            if(quote) {
                break;
            } else if(mode === 0) {
                mode = 1;
                block += c;
                return;
            } else {
                numParen++;
            }
            break;
        case ')':
            if (quote) {
                break;
            } else if(mode === 1) {
                if(numParen === 0) {
                    mode = 0;
                    block += c;
                    appendResult();
                    return;
                } else {
                    numParen--;
                }
            }
            break;

        case ',':
            if (quote) {
                break;
            } else if(mode === 0) {
                appendResult();
                return;
            } else if (mode === 1) {
                if (numParen === 0 && !method.match(/^url$/i)) {
                    args.push(definition);
                    definition = '';
                    block += c;
                    return;
                }
            }
            break;
        }

        block += c;
        if (mode === 0) {
            method += c;
        } else {
            definition += c;
        }
    });

    appendResult();
    return results;
};

},{}],27:[function(_dereq_,module,exports){
var GradientContainer = _dereq_('./gradientcontainer');

function WebkitGradientContainer(imageData) {
    GradientContainer.apply(this, arguments);
    this.type = imageData.args[0] === "linear" ? GradientContainer.TYPES.LINEAR : GradientContainer.TYPES.RADIAL;
}

WebkitGradientContainer.prototype = Object.create(GradientContainer.prototype);

module.exports = WebkitGradientContainer;

},{"./gradientcontainer":9}],28:[function(_dereq_,module,exports){
function XHR(url) {
    return new Promise(function(resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url);

        xhr.onload = function() {
            if (xhr.status === 200) {
                resolve(xhr.responseText);
            } else {
                reject(new Error(xhr.statusText));
            }
        };

        xhr.onerror = function() {
            reject(new Error("Network Error"));
        };

        xhr.send();
    });
}

module.exports = XHR;

},{}]},{},[4])(4)
});